var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15234 0C4.11687 0 2.46094 1.65594 2.46094 3.69141C2.46094 5.72688 4.11687 7.38281 6.15234 7.38281C8.18781 7.38281 9.84375 5.72688 9.84375 3.69141C9.84375 1.65594 8.18781 0 6.15234 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2358 10.9014C11.1322 9.24602 9.28539 8.25781 7.29641 8.25781H5.00855C3.01957 8.25781 1.1725 9.24602 0.0691797 10.9014L0 11.0048V14H12.3047V11.0048L12.2358 10.9014Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.29c4730a.svg";
export { ForwardRef as ReactComponent };